export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const APP_NAME = process.env.REACT_APP_APP_NAME;
export const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL;
export const S3_BASE_MEDIA_URL = process.env.REACT_APP_TIGIRIS_S3_BASE_URL;
// export const S3_BASE_IMAGE_URL = process.env.REACT_APP_S3_BASE_URL;

//Button text
export const LOGIN_BTN = "Log in";
export const RESET_BTN = "Reset";
export const GO_BACK_BTN = "Go Back";
export const WELCOME_TXT = "Welcome Back !";
export const NUMBER_REGEX = /[^0-9]/g;
export const NAME_REGEX = /[^a-zA-Z\s]/g;

//api-method
export const API_METHOD = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};

export const STORAGE_KEY = {
  USER: "user",
  TOKEN: "token",
  PERMISSIONS: "permissions",
  LOGIN_STATE: "login",
};

export const PHONE_NUMBER_MAXLENGTH = 2;
export const COUNTRY_MAX_LENGTH = 3;
export const EMAIL_MAXLENGTH = 50;
export const NAME_MAXLENGTH = 75;
export const DESCRIPTION_MAXLENGTH = 250;
export const PASSWORD_MAXLENGTH = 15;
export const MEMBERSHIP_PRICE = 4;
export const LOGIN_USER_MAXLENGTH = 40;
export const LOGIN_PASSWORD_MAXLENGTH = 30;
export const EPISODE_LIST = [100, 200, 300, 400, 500];


export const rowTypes = [
  { id: 1, name: "Row1" },
  { id: 2, name: "Row2" },
];
export const types = [
  { id: 1, name: "Audio" },
  { id: 2, name: "Video" },
];

export const permissionsGroups = [
  { id: 1, name: "Post" },
  { id: 2, name: "Media" },
  { id: 3, name: "User" },
  { id: 4, name: "Master" },
  { id: 5, name: "Log" },
];

export const postTypes = [
  { id: 1, name: "Ad-post" },
  { id: 2, name: "Content-post" },
];
export const MediaTypes = [
  { id: 1, name: "Series" },
  { id: 2, name: "Packages" },
];
export const purchaseTypes = [
  { id: 1, name: "Free" },
  { id: 2, name: "Member" },
  { id: 3, name: "LifeTime Packages" },
];

export const bannerTypes = [
  { id: 1, name: "Series" },
  { id: 2, name: "Packages" },
  { id: 3, name: "Post" },
];
